import { backendApiClient } from '@geneo2-web/services-clients';
import { PAL_BASE_URL } from '@geneo2-web/shared-ui';
import { AxiosRequestConfig } from 'axios';

const GOOGLE_OAUTH_LOGIN_PATH = `${
  PAL_BASE_URL || ''
}/public/sso_user.service.v1.SsoUserLoginService/GoogleOauthLogin`;

interface GoogleOauthLoginResponse {
  user: {
    id: number;
  };
  token: string;
}

export async function googleOauthLoginApi(
  body: {
    credential: string;
  },
  options: AxiosRequestConfig = {}
): Promise<GoogleOauthLoginResponse> {
  options.headers = {
    ...options.headers,
    'x-tenant-name': 'schoolnet-cl',
  };
  return await backendApiClient.post<GoogleOauthLoginResponse>(
    GOOGLE_OAUTH_LOGIN_PATH,
    body,
    options
  );
}
